import React, { useEffect, useState } from "react";
import { HeartPulse } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ConditionResearch } from "@/components/evidence/ConditionResearch";
import { PubMedSearch } from "@/components/evidence/PubMedSearch";
import Library from "@/pages/Library";

export default function Evidence() {
  const { t, lang } = useLang();
  const { user } = useAuth();
  const [conditions, setConditions] = useState([]);

  useEffect(() => {
    api.get("/conditions").then(({ data }) => setConditions(data.conditions || []));
    document.title = `${t("ev.title")} | Suppev`;
  }, [t]);

  const props = { conditions, user, t, lang };
  return (
    <div className="mx-auto max-w-4xl space-y-8" data-testid="evidence-page">
      <div>
        <div className="flex flex-wrap items-center gap-2">
          <HeartPulse className="text-emerald-600" size={26} />
          <h1 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{t("ev.title")}</h1>
          <span className="rounded-full bg-amber-100 px-2 py-0.5 text-xs font-bold text-amber-700">{t("common.premium")}</span>
        </div>
        <p className="mt-2 max-w-2xl text-sm text-gray-600">{t("pubmed.conditionsSub")}</p>
      </div>
      <ConditionResearch {...props} />
      <Tabs defaultValue="search" className="w-full">
        <TabsList>
          <TabsTrigger value="search" data-testid="evidence-tab-search">{t("ev.tabSearch")}</TabsTrigger>
          <TabsTrigger value="library" data-testid="evidence-tab-library">{t("lib.title")}</TabsTrigger>
        </TabsList>
        <TabsContent value="search" className="pt-4"><PubMedSearch {...props} /></TabsContent>
        <TabsContent value="library" className="pt-4"><Library embedded /></TabsContent>
      </Tabs>
    </div>
  );
}
